const merchantNameColumn = ({ name = "merchantName" } = {}) => ({
	name,
	type: "input" as const,
	placeholder: "Merchant Name",
});

export default merchantNameColumn;
